module.exports = __webpack_public_path__ + "static/media/3-10.2dca3b4d.mp3";